
export default {
    host: process.env.NODE_ENV === "development" ? "https://test.nby.fsktzn.net" : "https://nby.fsktzn.com",
}